export enum ErrorText {
  'Required' = 'Diese Feld wird benötigt.',
  'Currency' = 'Wert muss aus mindestens einer Vor- und Zwei Nachkommastellen bestehen. Nachkommstellen mit einem Komma trennen.',
  'StartDate' = 'Startdatum wird benötigt.',
  'EndDate' = 'Enddatum wird benötigt.',
  'PostalCode' = 'Muss aus genau 5 Ziffern bestehen.',
}
